import { track, sendDataLayer } from "jiffy-analytics";

const BUSINESS_LINE = "print";
const PAGE_LOCATION = "new_custom_print_shirts_feb_2026";

function buildPayload(eventName, eventData) {
  return {
    genericEvent: true,
    event: "click",
    eventCategory: eventName,
    eventLabel: eventData.eventLabel ?? eventName,
    page_location: PAGE_LOCATION,
    business_line: BUSINESS_LINE,
    section_identifier:
      eventData.section_identifier || eventData.trigger_location || eventData.location || eventName,
    ...eventData
  };
}

export function trackEvent(eventName, eventData = {}) {
  track(eventName, { page: PAGE_LOCATION, ...eventData });
  sendDataLayer(buildPayload(eventName, eventData));
}

export function sendDataLayerEvent(eventName, eventData = {}) {
  sendDataLayer(buildPayload(eventName, eventData));
}
